<template>
  <v-dialog :value="open" @click:outside="closeDialog()" scrollable max-width="600">
    <ValidationObserver ref="templateFormObs" v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <!-- Header -->
        <v-card-title class="pa-0 shadow-1">
          <v-img :src="require('@/assets/illustrations/bg_modal_card.svg')" cover position="left bottom" height="65px">
            <v-card-title class="font-weight-medium primary--text">
              {{ EditMode ? "Actualizar" : "Crear" }} Cita
            </v-card-title>
          </v-img>
        </v-card-title>

        <!-- Body -->
        <vuescroll :ops="{ bar: { background: '#bacfcec0', keepShow: true } }">
          <v-card-text style="max-height: 570px">
            <v-form>
              <v-row dense>
                <!-- Contact -->
                <v-col cols="12">
                  <ValidationProvider name="Contacto" :rules="addContact ? '' : 'required'" v-slot="{ errors }">
                    <v-autocomplete
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Contacto"
                      :items="contactList"
                      item-text="name"
                      item-value="id"
                      color="blue-grey"
                      v-model="formData.contact_id"
                      :loading="isLoadingContacts"
                      :error-messages="errors"
                      :hide-details="errors.length === 0"
                    />
                  </ValidationProvider>
                </v-col>

                <v-col v-if="addContact" cols="12">
                  <v-card flat color="grey lighten-4" class="mb-2">
                    <v-card-text>
                      <h6>Nuevo contacto</h6>
                      <v-divider class="mb-3" />
                      <ValidationProvider name="Teléfono" rules="required" v-slot="{ errors }">
                        <v-text-field
                          filled
                          rounded
                          class="rounded-small"
                          dense
                          label="Teléfono"
                          v-model="formData.contact.phone"
                          :error-messages="errors"
                        />
                      </ValidationProvider>

                      <ValidationProvider name="Nombre" rules="required" v-slot="{ errors }">
                        <v-text-field
                          filled
                          rounded
                          class="rounded-small"
                          dense
                          label="Nombre y apellido"
                          v-model="formData.contact.contactname"
                          :error-messages="errors"
                        />
                      </ValidationProvider>

                      <ValidationProvider name="DNI" rules="required" v-slot="{ errors }">
                        <v-text-field
                          filled
                          rounded
                          class="rounded-small"
                          dense
                          label="DNI"
                          v-model="formData.contact.dni_contact"
                          :error-messages="errors"
                        />
                      </ValidationProvider>
                    </v-card-text>
                  </v-card>
                </v-col>

                <div v-if="!isEdit" class="pb-3">
                  ¿No aparece tu contacto en la lista?
                  <v-btn v-if="!addContact" depressed x-small @click="addContact = true">
                    Añadir contacto nuevo
                  </v-btn>
                  <v-btn v-else text color="error" x-small @click="addContact = false">
                    cerrar
                  </v-btn>
                </div>

                <!-- tipo -->
                <v-col cols="12">
                  <ValidationProvider name="tipo de mensaje" rules="required" v-slot="{ errors }">
                    <v-autocomplete
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Tipo de mensaje"
                      :items="[
                        { id: 1, title: 'SMS' },
                        { id: 2, title: 'WhatsApp' },
                        { id: 3, title: 'Voice' },
                      ]"
                      item-text="title"
                      item-value="id"
                      color="blue-grey"
                      v-model="formData.send_type"
                      :error-messages="errors"
                    />
                  </ValidationProvider>
                </v-col>

                <!-- Template -->
                <v-col cols="12">
                  <ValidationProvider name="Plantilla" rules="required" v-slot="{ errors }">
                    <v-autocomplete
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Plantilla"
                      :items="templateList"
                      item-text="title"
                      item-value="id"
                      color="blue-grey"
                      v-model="formData.template_id"
                      :loading="isLoadingTemplates"
                      :error-messages="errors"
                    />
                  </ValidationProvider>
                </v-col>

                <!-- Specialty -->
                <v-col cols="12">
                  <ValidationProvider name="Especialidad" :rules="addSpecialty ? '' : 'required'" v-slot="{ errors }">
                    <v-autocomplete
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Especialidad"
                      :items="specialtiesList"
                      item-text="name"
                      item-value="id"
                      color="blue-grey"
                      v-model="formData.specialty_id"
                      :loading="isLoadingSpecialties"
                      :error-messages="errors"
                      :hide-details="errors.length === 0"
                    />
                  </ValidationProvider>
                </v-col>

                <template v-if="[1, 2].includes(CurrentRole)">
                  <div v-if="!isEdit" class="pb-3">
                    ¿No aparece la especialidad en la lista?
                    <v-btn v-if="!addSpecialty" depressed x-small @click="addSpecialty = true">
                      Añadir especialidad nueva
                    </v-btn>
                    <v-btn v-else text color="error" x-small @click="addSpecialty = false">
                      cerrar
                    </v-btn>
                  </div>
                </template>

                <v-col v-if="addSpecialty" cols="12">
                  <v-card flat color="grey lighten-4" class="mb-2">
                    <v-card-text>
                      <h6>Nueva especialidad</h6>
                      <v-divider class="mb-3" />
                      <ValidationProvider name="Especialidad" rules="required" v-slot="{ errors }">
                        <v-text-field
                          filled
                          rounded
                          class="rounded-small"
                          dense
                          label="Nombre de especialidad"
                          v-model="formData.specialty.name"
                          :error-messages="errors"
                        />
                      </ValidationProvider>
                    </v-card-text>
                  </v-card>
                </v-col>

                <!-- Responsible -->
                <v-col cols="12">
                  <ValidationProvider name="Responsable" :rules="addResponsible ? '' : 'required'" v-slot="{ errors }">
                    <v-autocomplete
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Responsable"
                      :items="responsibleList"
                      item-text="name"
                      item-value="id"
                      color="blue-grey"
                      :disabled="!formData.specialty_id"
                      v-model="formData.responsible_id"
                      :loading="isLoadingResponsible"
                      :error-messages="errors"
                      :hide-details="errors.length === 0"
                    />
                  </ValidationProvider>
                </v-col>

                <template v-if="[1, 2].includes(CurrentRole)">
                  <div v-if="!isEdit" class="pb-3">
                    ¿No aparece el responsable en la lista?
                    <v-btn v-if="!addResponsible" depressed x-small @click="addResponsible = true">
                      Añadir responsable nuevo
                    </v-btn>
                    <v-btn v-else text color="error" x-small @click="addResponsible = false">
                      cerrar
                    </v-btn>
                  </div>
                </template>

                <v-col v-if="addResponsible" cols="12">
                  <v-card flat color="grey lighten-4" class="mb-2">
                    <v-card-text>
                      <h6>Nuevo responsable</h6>
                      <v-divider class="mb-3" />
                      <ValidationProvider name="Responsable" rules="required" v-slot="{ errors }">
                        <v-text-field
                          filled
                          rounded
                          class="rounded-small"
                          dense
                          label="Nombre del responsable"
                          v-model="formData.responsible.name"
                          :error-messages="errors"
                        />
                      </ValidationProvider>
                    </v-card-text>
                  </v-card>
                </v-col>

                <!-- Contact -->
                <v-col cols="12">
                  <ValidationProvider name="Contacto" :rules="addContact ? '' : 'required'" v-slot="{ errors }">
                    <v-autocomplete
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Contacto"
                      :items="contactList"
                      item-text="name"
                      item-value="id"
                      color="blue-grey"
                      v-model="formData.contact_id"
                      :loading="isLoadingContacts"
                      :error-messages="errors"
                      :hide-details="errors.length === 0"
                    />
                  </ValidationProvider>
                </v-col>

                <div v-if="!isEdit" class="pb-3">
                  ¿No aparece tu contacto en la lista?
                  <v-btn v-if="!addContact" depressed x-small @click="addContact = true">
                    Añadir contacto nuevo
                  </v-btn>
                  <v-btn v-else text color="error" x-small @click="addContact = false">
                    cerrar
                  </v-btn>
                </div>

                <v-col v-if="addContact" cols="12">
                  <v-card flat color="grey lighten-4" class="mb-2">
                    <v-card-text>
                      <h6>Nuevo contacto</h6>
                      <v-divider class="mb-3" />
                      <ValidationProvider name="Teléfono" rules="required" v-slot="{ errors }">
                        <v-text-field
                          filled
                          rounded
                          class="rounded-small"
                          dense
                          label="Teléfono"
                          v-model="formData.contact.phone"
                          :error-messages="errors"
                        />
                      </ValidationProvider>

                      <ValidationProvider name="Nombre" rules="required" v-slot="{ errors }">
                        <v-text-field
                          filled
                          rounded
                          class="rounded-small"
                          dense
                          label="Nombre y apellido"
                          v-model="formData.contact.contactname"
                          :error-messages="errors"
                        />
                      </ValidationProvider>

                      <ValidationProvider name="DNI" rules="required" v-slot="{ errors }">
                        <v-text-field
                          filled
                          rounded
                          class="rounded-small"
                          dense
                          label="DNI"
                          v-model="formData.contact.dni_contact"
                          :error-messages="errors"
                        />
                      </ValidationProvider>
                    </v-card-text>
                  </v-card>
                </v-col>

                <!-- Date -->
                <v-col cols="12">
                  <ValidationProvider name="Fecha" rules="required" v-slot="{ errors }">
                    <v-datetime-picker
                      label="Fecha"
                      v-model="formData.appointment_date"
                      :textFieldProps="{
                        filled: true,
                        rounded: true,
                        dense: true,
                        required: true,
                        class: 'rounded-small',
                        'error-messages': errors,
                      }"
                      :datePickerProps="{
                        scrollable: true,
                        'no-title': true,
                        color: 'success',
                      }"
                      :timePickerProps="{
                        scrollable: true,
                        'no-title': true,
                        color: 'success',
                      }"
                      okText="Guardar"
                      clearText="Limpiar"
                    >
                      <template v-slot:dateIcon>
                        <v-icon dark> mdi-calendar </v-icon>
                      </template>
                      <template v-slot:timeIcon>
                        <v-icon dark> mdi-clock-outline </v-icon>
                      </template>
                    </v-datetime-picker>
                  </ValidationProvider>
                </v-col>

                <!-- address -->
                <v-col cols="12">
                  <ValidationProvider name="direccion de sede" :rules="'required'" v-slot="{ errors }">
                    <v-text-field
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Dirección de sede"
                      color="blue-grey"
                      v-model="formData.address"
                      :error-messages="errors"
                      :hide-details="errors.length === 0"
                    />
                  </ValidationProvider>
                </v-col>

                <!-- Observations -->
                <v-col cols="12">
                  <v-textarea
                    filled
                    rounded
                    class="rounded-small"
                    dense
                    label="Observaciones"
                    v-model="formData.observations"
                  />
                </v-col>

                <!-- Consecutivo -->
                <v-col cols="12">
                  <v-text-field
                    filled
                    rounded
                    class="rounded-small"
                    dense
                    label="Consecutivo Krystalos"
                    v-model="formData.consecutivo_krystalos"
                  />
                </v-col>

                <!-- Send switch -->
                <v-col cols="12">
                  <v-switch v-model="formData.send" label="Enviar" color="success" inset />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </vuescroll>

        <!-- Actions -->
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn text color="grey" @click="closeDialog()">Cancelar</v-btn>
          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="isLoading"
              :disabled="isLoading"
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click.stop="handleSubmit(submitForm)"
            >
              {{ EditMode ? "Guardar" : "Crear" }}
            </v-btn>
          </v-hover>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import moment from "moment";
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";

export default {
  components: { vuescroll },

  props: {
    open: Boolean,
    isEdit: Boolean,
    editData: Object,
  },

  data() {
    return {
      isLoading: false,
      isLoadingTemplates: false,
      isLoadingContacts: false,
      isLoadingSpecialties: false,
      isLoadingResponsible: false,

      addSpecialty: false,
      addResponsible: false,
      addContact: false,

      templateList: [],
      contactList: [],
      specialtiesList: [],
      responsibleList: [],

      formData: {
        contact_id: null,
        user_id: null,
        appointment_date: "",
        send_type: 2,
        send: true,
        template_id: null,
        observations: "",
        specialty_id: null,
        responsible_id: null,
        consecutivo_krystalos: "",
        contact: null,
        specialty: null,
        responsible: null,
        address: "",
      },
    };
  },

  computed: {
    EditMode() {
      return !!this.editData;
    },
    User() {
      return this.$store.getters["passport/CURRENT_USER"];
    },

    CurrentRole() {
      return this.$store.getters["passport/GET_ROLE"];
    },
  },

  watch: {
    addContact(val) {
      if (val && !this.formData.contact) {
        this.formData.contact = { phone: "", contactname: "", dni_contact: "" };
        this.formData.contact_id = null;
      }
    },
    addSpecialty(val) {
      if (val && !this.formData.specialty) {
        this.formData.specialty = { name: "" };
        this.formData.specialty_id = null;
      }
    },
    addResponsible(val) {
      if (val && !this.formData.responsible) {
        this.formData.responsible = { name: "" };
        this.formData.responsible_id = null;
      }
    },
    editData: {
      handler(val) {
        if (val) {
          this.fillForm(val);
        }
      },
      immediate: true,
      deep: true,
    },

    open(val) {
      if (val) {
        this.getTemplates();
        this.getSpecialties();
        this.getResponsibles();
        this.getContacts();
      }
    },
  },

  methods: {
    closeDialog(item) {
      this.$emit("dialog:close", item);
      this.$refs.templateFormObs.reset();

      this.formData = {
        contact_id: null,
        user_id: null,
        appointment_date: "",
        send_type: 2,
        send: true,
        template_id: null,
        observations: "",
        specialty_id: null,
        responsible_id: null,
        consecutivo_krystalos: "",
        contact: null,
        specialty: null,
        responsible: null,
        address: "",
      };

      this.addContact = this.addSpecialty = this.addResponsible = false;
    },

    fillForm(data) {
      this.formData = {
        contact_id: data.contact?.id || null,
        user_id: data.user_id || null,
        appointment_date: data.appointment_date || "",
        send_type: data.send_type || 2,
        send: data.send ?? true,
        template_id: data.template?.id || null,
        observations: data.observations || "",
        specialty_id: data.specialty?.id || null,
        responsible_id: data.responsible?.id || null,
        consecutivo_krystalos: data.consecutivo_krystalos || "",
        contact: null,
        specialty: null,
        responsible: null,
        address: data.address || "",
      };
    },

    async getTemplates() {
      this.isLoadingTemplates = true;
      try {
        const { data } = await PbxHttpClient.get("/module_appointment/templates_appointments_select");
        this.templateList = data;
      } catch (error) {
        console.log(error);
      }
      this.isLoadingTemplates = false;
    },

    async getContacts() {
      this.isLoadingContacts = true;
      try {
        const { data } = await PbxHttpClient.get("/contacts/select");
        this.contactList = data;

        if (this.editData) this.fillForm(this.editData);
      } catch (error) {
        console.log(error);
      }
      this.isLoadingContacts = false;
    },

    async getSpecialties() {
      this.isLoadingSpecialties = true;
      try {
        const { data } = await PbxHttpClient.get("/module_appointment/specialties_select");
        this.specialtiesList = data;
      } catch (error) {
        console.log(error);
      }
      this.isLoadingSpecialties = false;
    },

    async getResponsibles() {
      this.isLoadingResponsible = true;
      try {
        const { data } = await PbxHttpClient.get("/module_appointment/responsibles_select");
        this.responsibleList = data.map((el) => ({ ...el, name: `${el.name} ${el.last_name}` }));
      } catch (error) {
        console.log(error);
      }
      this.isLoadingResponsible = false;
    },

    async submitForm() {
      this.isLoading = true;
      try {
        const payload = {
          ...this.formData,
          appointment_date: moment(this.formData.appointment_date).format("YYYY-MM-DD HH:mm:ss"),
          user_id: this.EditMode ? undefined : this.User.id,
        };

        const { data } = this.EditMode
          ? await PbxHttpClient.put(`/module_appointment/appointments/${this.editData.id}`, payload)
          : await PbxHttpClient.post("/module_appointment/appointments", payload);

        this.$snotify.success(this.EditMode ? "Cita actualizada" : "Cita creada", "¡Hecho!");
        this.closeDialog(data);
      } catch {
        this.$snotify.error("Error al guardar la cita", "Error");
      }
      this.isLoading = false;
    },
  },
};
</script>
